import React, { useState, useEffect } from 'react';
import axios from 'axios';
import WeekSelector from '../weekSelector';
import { useTranslation } from 'react-i18next';

const WeeklyStats = () => {
  const [stats, setStats] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [hideInactive, setHideInactive] = useState(false);
  const { t } = useTranslation();

  const fetchStats = (week) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    axios.get('/api/weekly-stats', {
      params: { week },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then(res => setStats(res.data))
      .catch(err => console.error('Помилка завантаження:', err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (selectedWeek !== null) {
      fetchStats(selectedWeek);
    }
  }, [selectedWeek]);
  const sortData = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  useEffect(() => {
    const savedHideInactive = localStorage.getItem('hideInactive');
    if (savedHideInactive !== null) {
      setHideInactive(savedHideInactive === 'true');
    }
  }, []);

  const sortedStats = React.useMemo(() => {
    let sortableStats = [...stats];
    if (sortConfig.key !== null) {
      sortableStats.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'ascending' ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'ascending' ? 1 : -1;
        return 0;
      });
    }
    return sortableStats;
  }, [stats, sortConfig]);

  const getSortEmoji = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽';
    }
    return '';
  };

  return (
    <div className="container">
      <h2>{t("weeklystats")}</h2>

      <div className="d-flex align-items-center mb-3">
        <WeekSelector
          selectedWeek={selectedWeek}
          setSelectedWeek={setSelectedWeek}
        />
        {loading && <span className="ms-3 text-muted">{t("loading")}</span>}
      </div>
      <div
        className="mt-3 border border-primary rounded"
        style={{
          backgroundColor: "#f8f9fa",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
        }}
      >
        <div className="d-flex align-items-center px-3 py-2">
          <input
            className="form-check-input"
            type="checkbox"
            id="hideInactiveCheckbox"
            checked={hideInactive}
            style={{
              transform: "scale(1.5)",
              cursor: "pointer",
              marginRight: "15px"
            }}
            onChange={() => {
              setHideInactive(prev => {
                const newValue = !prev;
                localStorage.setItem('hideInactive', newValue);
                return newValue;
              });
            }}
          />
          <label
            className="form-check-label fw-bold m-0"
            htmlFor="hideInactiveCheckbox"
            style={{ fontSize: "1.1rem" }}
          >
            🚫 {t("hidedriverswithoutincomings")} Uber / Bolt / FreeNow
          </label>
        </div>
      </div>






      {sortedStats.length > 0 && (
        <table className="table table-bordered mt-4">
          <thead className="table-white text-center sticky-top bg-dark" style={{ zIndex: 10 }}>
            <tr>
              <th style={{ cursor: 'pointer' }} onClick={() => sortData('firstName')}>
                {t("name")}{getSortEmoji('firstName')}
              </th>
              <th style={{ cursor: 'pointer' }} onClick={() => sortData('lastName')}>
                {t("surname")}{getSortEmoji('lastName')}
              </th>
              <th style={{ width: "12.5%" }}>
                <a href="/admin/edit-source-data/uber" className="text-black" title="Uber">Uber</a>
              </th>
              <th style={{ width: "12.5%" }}>
                <a href="/admin/edit-source-data/bolt" className="text-black" title="Bolt">Bolt</a>
              </th>
              <th style={{ width: "12.5%" }}>
                <a href="/admin/edit-source-data/freenow" className="text-black" title="FreeNow">FreeNow</a>
              </th>
              <th style={{ width: "12.5%" }}>
                <a href="/admin/driver-debts" className="text-black" title={t("viewalldebts")}>
                  {t("debts")}
                </a>
              </th>
              <th style={{ width: "12.5%" }}>
                <a href="/admin/driver-extra-funds" className="text-black" title={t("extraCosts")}>
                  {t("extraCosts")}
                </a>
              </th>
              <th style={{ width: "12.5%" }}>
                <a href="/admin/check-reports" className="text-black" title={t("published")}>
                  {t("report")} {t("published").toLocaleLowerCase()}
                </a>
              </th>
            </tr>
          </thead>

          <tbody>
            {sortedStats
              .filter(user => {
                if (!hideInactive) return true;
                return user.hasUber || user.hasBolt || user.hasFreeNow;
              })
              .map(user => (
                <tr
                  key={user.id}
                  className={
                    user.hasPublishedReport
                      ? "table-success"
                      : (!user.hasUber && !user.hasBolt && !user.hasFreeNow && !user.hasDebt && !user.hasExtraFunds)
                        ? "table-danger"
                        : "table-warning"
                  }
                >

                  <td>{user.firstName}</td>
                  <td>{user.lastName}</td>
                  <td>{user.hasUber ? '✅' : '❌'}</td>
                  <td>{user.hasBolt ? '✅' : '❌'}</td>
                  <td>{user.hasFreeNow ? '✅' : '❌'}</td>
                  <td>
                    {user.hasDebt ? '✅' : (
                      <a
                        href={`/admin/driver-debts?openModal=true&driverId=${user.id}&week=${selectedWeek}`}
                        className="text-decoration-none"
                        title={t("newdebt")}
                      >
                        ❌
                      </a>
                    )}
                  </td>
                  <td>
                    <a
                      href={
                        user.extraFundsId
                          ? `/admin/edit-extra-funds/${user.extraFundsId}`
                          : `/admin/edit-extra-funds?driver_id=${user.id}&week_number=${selectedWeek}`
                      }
                      className="text-decoration-none"
                      title={user.hasExtraFunds ? t("editextracosts") : t("newextracosts")}
                    >
                      {user.hasExtraFunds ? '✅' : '❌'}
                    </a>

                  </td>

                  <td>
                    {user.hasPublishedReport ? (
                      <a
                        href={`/admin/check-reports`}
                        className="text-success text-decoration-none"
                        title={t("checkreport")}
                      >
                        ✅
                      </a>
                    ) : (
                      <a
                        href={`/admin/driver-raport?driverId=${user.id}&week=${selectedWeek}`}
                        className="text-danger text-decoration-none"
                        title={t("createreport")}
                      >
                        ❌
                      </a>
                    )}
                  </td>


                </tr>
              ))}
          </tbody>
        </table>

      )}

      {sortedStats.length === 0 && selectedWeek !== null && !loading && (
        <p className="mt-4">{t("noRecords")}</p>
      )}

      {selectedWeek === null && (
        <p className="mt-4">{t("choose")} {t("week").toLocaleLowerCase()}</p>
      )}
      <div className="alert alert-info mt-4" role="alert">
        <strong>{t("hilightsdesc")}</strong><br />
        <span className="badge bg-success me-2">{t("green")}</span>{t("greendesc")}<br />
        <span className="badge bg-warning text-dark me-2">{t("yellow")}</span>{t("yellowdesc")}<br />
        <span className="badge bg-danger me-2">{t("red")}</span>{t("reddesc")}
      </div>
    </div>
  );
};

export default WeeklyStats;
